import React from 'react';

const VsCodeLogo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2500 2455" >
            <path fill="#2489CA" d="M188,913.1c0,0-53.4-38.5,10.7-89.9l149.3-133.5c0,0,42.7-44.9,87.9-5.8l1377.6,1043v500.1  c0,0-0.7,78.5-101.4,69.9L188,913.1z" />
            <path fill="#1070B3" d="M543,1235.5L188,1558.3c0,0-36.5,27.1,0,75.6l164.9,149.9c0,0,39.2,42,97-5.8l376.4-285.4L543,1235.5z" />
            <path fill="#0877B9" d="M1166.4,1238.2L1817.6,741l-4.2-497.5c0,0-27.8-108.6-120.6-52.1L826.2,980.1L1166.4,1238.2z" />
            <path fill="#3C99D4" d="M1711.9,2297.6c37.8,38.7,83.7,26,83.7,26l507.5-250.1c65-44.3,55.8-99.2,55.8-99.2V481.1  c0-65.6-67.2-88.3-67.2-88.3l-439.8-212c-96.1-59.4-159.1,10.7-159.1,10.7s81-58.3,120.6,52.1V2218c0,13.6-2.9,26.9-8.7,38.9  c-11.6,23.4-36.7,45.2-97,36L1711.9,2297.6z" />
        </svg>
    )
}

export default VsCodeLogo;